export enum MailAssignStatus {
  NOT_YET_ASSIGNED = 'NOT_YET_ASSIGNED',
  ALREADY_ASSIGNED = 'ALREADY_ASSIGNED',
  ITEM_IGNORED = 'ITEM_IGNORED',
  ASSIGNED_TO_OBJECT = 'ASSIGNED_TO_OBJECT',
  ASSIGNED_TO_OBJECT_AND_MAIL = 'ASSIGNED_TO_OBJECT_AND_MAIL',
}
